import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import PropTypes from 'prop-types';

import PhoneNumberVerificationComponent from './PhoneNumberVerificationComponent';

import { verifyPhoneNumber } from './actions';

const PhoneNumberVerificationContainer = (props) => {
  const { buildingId, onModalClose } = props;

  const dispatch = useDispatch();

  const [verificationCode, setVerificationCode] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  const onVerifyPhoneNumber = async () => {
    const code = await verifyPhoneNumber(dispatch, buildingId);
    setIsLoading(false);
    if (code) {
      setVerificationCode(code);
    } else {
      onModalClose();
    }
  };

  useEffect(() => {
    onVerifyPhoneNumber();
  }, []);

  return (
    <PhoneNumberVerificationComponent
      verificationCode={verificationCode}
      isLoading={isLoading}
      onModalClose={onModalClose}
    />
  );
};

PhoneNumberVerificationContainer.propTypes = {
  buildingId: PropTypes.string.isRequired,
  onModalClose: PropTypes.func.isRequired,
};

export default PhoneNumberVerificationContainer;
